import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input
} from '@angular/core';

/**
 * `<labs-container>` displays a centered container with a gutter and optional sizes.
 * Containers should **not** be nested.
 */
@Component({
  selector: 'labs-container',
  template: '<ng-content></ng-content>',
  styleUrls: ['./container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContainerComponent {
  @HostBinding('class')
  @Input()
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '' = '';
}
